module.exports = __webpack_public_path__ + "img/closeModal.b7a84970.svg";